<template>
  <div class="container-fluid add-issue-page">
    <div v-if="!submitted" class="add-issue-sheet">
      <div class="form-section">
        <h5>{{ $t('issue.description') }}</h5>
        <div class="row">
          <div class="col-md-4">
            <div class="field">
              <label for="issueType">{{ $t('issue.type') }}</label>
              <select id="issueType" v-model="issue.issueType" class="custom-select">
                <option :value="null" />
                <option :value="''">
                  Smartdrone
                </option>
                <option :value="'Presupuesto'">
                  Presupuesto
                </option>
                <option :value="'Sancor'">
                  Sancor Seguros
                </option>
                <option :value="'Daferol'">
                  Daferol
                </option>
                <option :value="'Termalesuy'">
                  Termalesuy
                </option>
                <option :value="'AMV'">
                  AMV
                </option>
                <option :value="'Zerisur'">
                  Zerisur
                </option>
                <option :value="'PcService'">
                  PcService
                </option>
              </select>
            </div>
            <div class="field">
              <label for="priority">Sucursal</label>
              <select id="priority" v-model="issue.priority" class="custom-select">
                <option value="null" />
                <option v-for="(aPriority, index) in priorityArray" :key="index" :value="aPriority">
                  {{ aPriority.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-8">
            <div class="field">
              <label for="description">{{ $t('issue.initial_description') }}</label>
              <textarea id="description" v-model="issue.description" class="form-control ta-fill" required name="description" />
              <span v-if="msg.description" class="alert-msg">{{msg.description}}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="form-section">
        <h5>{{ $t('issue.customer_info') }}</h5>
        <div v-if="customers.length" class="suggestions">
          <div class="list-group mb-3">
            <div class="list-group-item justify-content-between align-items-center active">
              {{ $t('issue.customer_sug') }}
              <span class="badge badge-secondary badge-pill">{{customers.length}}</span>
            </div>
            <a v-for="(customer, index) in customers.slice(0, 5)" :key="index" href="#" class="list-group-item list-group-item-action" @click="selectCustomer(customer)">
              {{customer.firstName}} ({{customer.phone}})
            </a>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <div class="field">
              <label for="customerName">{{ $t('common.name') }}</label>
              <input id="customerName" v-model="issue.customer.firstName" autocomplete="disabled" :disabled="selectedCustomer" required :placeholder="$t('issue.name_placeholder')" class="form-control" name="customerName">
              <span v-if="msg.customerName" class="alert-msg">{{msg.customerName}}</span>
            </div>
          </div>
          <div class="col-md-4">
            <div class="field">
              <label for="customerPhone">{{ $t('common.phone') }}</label>
              <input id="customerPhone" v-model="issue.customer.phone" autocomplete="disabled" :disabled="selectedCustomer" required :placeholder="$t('issue.phone_placeholder')" type="number" class="form-control" name="customerPhone">
              <span v-if="msg.customerPhone" class="alert-msg">{{msg.customerPhone}}</span>
            </div>
          </div>
          <div class="col-md-4">
            <div class="field">
              <label for="customerEmail">{{ $t('common.mail') }}</label>
              <div class="field-with-action">
                <input id="customerEmail" v-model="issue.customer.email" autocomplete="disabled" :disabled="selectedCustomer || disableEmail" required :placeholder="$t('issue.mail_placeholder')" type="email" class="form-control" name="customerEmail">
                <button class="btn btn-outline-secondary" type="button" :disabled="selectedCustomer" @click="toggleEmailInput">
                  <span v-if="!disableEmail">{{ $t('action.no_email') }}</span>
                  <span v-else>{{ $t('action.activate') }}</span>
                </button>
              </div>
              <span v-if="msg.customerEmail" class="alert-msg">{{msg.customerEmail}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="form-section">
        <h5>{{ $t('issue.document_info') }}</h5>
        <div class="row">
          <div class="col-sm-8">
            <div class="field">
              <label for="documentReferredId">{{ $t('issue.document_number') }}</label>
              <input id="documentReferredId" v-model="issue.documentReferredId" :disabled="issue.issueType==='Presupuesto'" :placeholder="$t('issue.document_number')" type="text" class="form-control" name="documentReferredId">
            </div>
          </div>
          <div class="col-sm-4">
            <div class="field">
              <label for="documentReferredDate">{{ $t('common.date') }}</label>
              <input id="documentReferredDate" v-model="issue.documentReferredDate" :disabled="issue.issueType==='Presupuesto'" type="date" class="form-control" name="documentReferredDate">
              <p v-if="dateCalc" class="date-hint">
                {{dateCalc}}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="form-section">
        <h5>{{ $t('issue.device_info') }}</h5>
        <div class="row">
          <div class="col-md-4">
            <div class="field">
              <label for="deviceBrand">{{ $t('issue.device_brand') }}</label>
              <input id="deviceBrand" v-model="issue.deviceBrand" :placeholder="$t('issue.device_brand')" class="form-control" required name="deviceBrand">
              <span v-if="msg.deviceBrand" class="alert-msg">{{msg.deviceBrand}}</span>
            </div>
          </div>
          <div class="col-md-4">
            <div class="field">
              <label for="sku">SKU</label>
              <input id="sku" v-model="issue.sku" class="form-control" name="sku">
              <span v-if="msg.sku" class="alert-msg">{{msg.sku}}</span>
            </div>
          </div>
          <div class="col-md-4">
            <div class="field">
              <label for="serialNo">{{ $t('issue.device_serial') }}</label>
              <input id="serialNo" v-model="issue.serialNo" :placeholder="$t('issue.device_serial')" class="form-control" required name="serialNo">
              <span v-if="msg.serialNo" class="alert-msg">{{msg.serialNo}}</span>
            </div>
          </div>
        </div>
        <div v-if="issue.serialNo" class="row">
          <div v-if="relatedIssues.length" class="col-12">
            <div class="list-group mt-3">
              <div class="list-group-item justify-content-between align-items-center active">
                <!-- {{ $t('issue.customer_sug') }} -->
                Tickets del {{issue.serialNo}}
                <span class="badge badge-secondary badge-pill">{{relatedIssues.length}}</span>
              </div>
              <span v-for="(relatedIssue, index) in relatedIssues.slice(0, 5)" :key="index" class="list-group-item list-group-item-action">
                #{{getTicketId(relatedIssue)}} - {{relatedIssue.customer.firstName}} ({{relatedIssue.customer.phone}}) [{{relatedIssue.status2 ? relatedIssue.status2.name : 'Nuevo' }}] - {{ formatDate(relatedIssue.dateCreated) }}
              </span>
            </div>
          </div>
          <div v-else class="col-12 mt-3">
            <button class="btn btn-outline-primary" @click="checkForSerial">
              Revisar Imei
            </button>
          </div>
        </div>
      </div>

      <div class="form-section">
        <h5>{{ $t('common.extra_fields') }}</h5>
        <div class="row">
          <div v-for="(extraField, index) in extraFields" :key="index" data-toggle="tooltip" data-placement="top" :title="extraField.description" class="col-md-6">
            <div v-if="extraField.writePermissions === 'EMPLOYEES'" class="field">
              <label>{{extraField.name}}</label>
              <textarea v-if="extraField.type === 'TEXTAREA'" v-model="issueValues[extraField.id]" :placeholder="'Ingrese '+extraField.name" class="form-control" />
              <input v-else-if="extraField.type === 'STRING'" v-model="issueValues[extraField.id]" :placeholder="'Ingrese '+extraField.name" type="text" class="form-control">
              <input v-else-if="extraField.type === 'NUMBER'" v-model="issueValues[extraField.id]" :placeholder="'Ingrese '+extraField.name" type="number" class="form-control">
              <select v-else-if="extraField.type === 'SELECT'" v-model="issueValues[extraField.id]" class="form-control form-select">
                <option v-for="(option, index1) in extraField.extraFieldOptions" :key="index1" :value="option.value">
                  {{ option.name }}
                </option>
              </select>
              <div v-else-if="extraField.type === 'BOOLEAN' && extraField.name === 'Encomienda'" class="radio-pair">
                <label><input :name="extraField.id" type="radio" @click="forzarEncomienda(extraField.id, true)"> Si</label>
                <label><input :name="extraField.id" type="radio" @click="forzarEncomienda(extraField.id, false)"> No</label>
              </div>
              <div v-else-if="extraField.type === 'BOOLEAN'" class="checkbox-single">
                <input v-model="issueValues[extraField.id]" type="checkbox">
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="form-actions">
        <button class="btn btn-success" @click="saveIssue">
          {{ $t('action.save') }}
        </button>
        <button class="btn btn-outline-danger btn-reset" @click="newCustomer">
          {{ $t('action.reset') }}
        </button>
      </div>
    </div>

    <div v-else class="success-panel">
      <h4>{{ $t('message.saved_ok') }}</h4>
      <button class="btn btn-success" @click="newCustomer">
        {{ $t('action.save_another') }}
      </button>
    </div>
  </div>
</template>

<script>
import IssueService from '@/services/issue.service';
import PriorityService from '@/services/priority.service';
import ExtraFieldService from '@/services/extrafield.service';
import CustomerService from '@/services/customer.service';
import { getTicketId, formatDate } from '@/utils/page-utils';

export default {
    name: 'AddIssue',
    data() {
        return {
            customers: [],
            priorityArray: [],
            processing: false,
            selectedCustomer: false,
            disableEmail: false,
            issue: {
                description: '',
                issueType: null,
                priority: null,
                customer: {
                    id: -1,
                    firstName: '',
                    email: '',
                    phone: ''
                },
                documentReferredId: '',
                documentReferredDate: '',
                deviceBrand: '',
                sku: '',
                serialNo: ''
            },
            extraFields: [],
            issueValues: {},
            msg: {
                customerEmail: '',
                customerName: '',
                customerPhone: '',
                description: '',
                deviceBrand: '',
                sku: '',
                serialNo: ''
            },
            relatedIssues: [],
            submitted: false
        };
    },
    computed: {
        dateCalc() {
            const dateSplitted = this.issue.documentReferredDate.split(/\D/);
            const today = new Date();
            let docDate, diffDate, returnVal = 'Han pasado ';

            if (dateSplitted.length > 1) {
                docDate = new Date(dateSplitted[0], --dateSplitted[1], dateSplitted[2]);
                if (today - docDate < 0) {
                    return 'La fecha de la factura está en el futuro.';
                }
                diffDate = new Date(today - docDate);

                returnVal += diffDate.toISOString().slice(0, 4) - 1970 > 0 ?
                    diffDate.toISOString().slice(0, 4) - 1970 + ' años ' :
                    '';
                returnVal += diffDate.getMonth() > 0 ?
                    diffDate.getMonth() + ' meses ' :
                    '';
                returnVal += diffDate.getDate() - 1 + ' dias.';

                return returnVal;
            }
            return '';
        }
    },
    watch: {
        'issue.customer.email': function watchEmail(value) {
            if (value.length > 3 && !this.selectedCustomer && value !== 'elusuarionotienemail@gmail.com') {
                this.customers = [];
                CustomerService.searchByField('email', value).then(
                    response => {
                        this.customers = response.data;
                    },
                    error => {
                        console.log(error.response && error.response.data ||
                  error.message || error.toString());
                    });

                if (value.length > 5) {
                    this.validateEmail(value);
                }
            }
        },
        'issue.customer.firstName': function watchName(value) {
            if (value.length > 2 && !this.selectedCustomer) {
                this.customers = [];
                this.msg['customerName'] = '';
                if (value.length > 3) {
                    CustomerService.searchByField('name', value).then(
                        response => {
                            this.customers = response.data;
                        },
                        error => {
                            console.log(error.response && error.response.data ||
                      error.message || error.toString());
                        });
                }
            }
        },
        'issue.customer.phone': function watchPhone(value) {
            if (value.length > 2 && !this.selectedCustomer) {
                this.customers = [];
                this.msg['customerPhone'] = '';
                if (value.length > 3) {
                    CustomerService.searchByField('phone', value).then(
                        response => {
                            this.customers = response.data;
                        },
                        error => {
                            console.log(error.response && error.response.data ||
                      error.message || error.toString());
                        });

                    if (value.length > 9) {
                        this.issue.customerPhone = value.substring(0, 9);
                    }
                }
            }
        },
        'issue.description': function watchDescription(value) {
            if (value.length > 2) {
                this.msg['description'] = '';
            }
        },
        'issue.deviceBrand': function watchDeviceBrand(value) {
            if (value.length > 2) {
                this.msg['deviceBrand'] = '';
            }
        },
        'issue.serialNo': function watchSerialNo(value) {
            if (value.length > 2) {
                this.msg['serialNo'] = '';
                // reset related issues if serial changed.
                this.relatedIssues = [];
            }
        }
    },
    created() {
        this.getPriorities();
        this.initializeExtrafields();
    },
    methods: {
    /* eslint-disable no-console */
        forzarEncomienda(index, value) {
            this.issueValues[index] = value;
        },
        checkForSerial() {
            IssueService.getIssuesBySerial(this.issue.serialNo).then(
                response => {
                    this.relatedIssues = response.data;
                },
                error => {
                    console.log(error.response && error.response.data ||
              error.message || error.toString());
                });
        },
        getPriorities() {
            PriorityService.getPriorities(true).then(
                response => {
                    this.priorityArray = response.data;
                },
                error => {
                    console.log(error.response && error.response.data ||
                  error.message || error.toString());
                }
            );
        },
        getTicketId,
        formatDate,
        sendMail(issue) {
            issue.emailSubject = 'Servicio Creado ' + this.getTicketId(issue);
            issue.emailBody = '<b>Servicio creado con éxito</b><br><p><b>Equipo: </b> ' + issue.deviceBrand + ' ' + issue.serialNo + 'SKU: ' + issue.sku + '</p><p>' + issue.issueDescription + '</p><br>';
            // agregado temporalmente.
            // issue.emailBody += '<p style="color:red;">Semana de carnaval cerrado por licencia anual.</p>';
            // issue.emailBody += '<br><p style="font-weight:bold;">Nos Mudamos!<br>';
            // issue.emailBody += 'Te esperamos en Gral. Flores 2830 esquina Ceibal.</p>';
            issue.emailBody += '<p style="font-weight:bold;">092062626 - 0947826651</p>';
            if (issue.issueType === 'AMV') {
                issue.bccAddress = 'garantias.smartdrone@amvstore.com.uy';
            } else if (issue.issueType === 'Termalesuy') {
                issue.bccAddress = 'termalesuy@gmail.com,damixd13@hotmail.com';
            } else if (issue.issueType === 'Zerisur') {
                issue.bccAddress = 'zerisur@gmail.com';
            }
            IssueService.sendMail(issue, 'customer').then(
                response => {},
                error => {
                    console.log(error.response && error.response.data ||
              error.message || error.toString());
                });
        },
        validateEmail(value) {
            if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value)) {
                this.msg['customerEmail'] = '';
            } else {
                this.msg['customerEmail'] = 'Ingrese correo correcto.';
            }
        },
        validForm(data) {
            if (data.issueType === null) {
                alert('Seleccione un Tipo de servicio.');
                return false;
            }

            if (data.priority === null) {
                alert('Seleccione una Sucursal');
                return false;
            }
            if (!this.issueValues[4]) {
                alert('Si no tiene Accesorios, pon NO.');
                return false;
            }
            if (this.issueValues[1] === '') {
                alert('Si no hay Encomienda, selecciona NO.');
                return false;
            }
            if (!this.selectedCustomer) {
                this.validateEmail(data.customer.email);
            }

            if (!this.selectedCustomer && (!data.customer.firstName || !data.customer.firstName.length ||
                !data.customer.phone || !data.customer.phone.length || this.msg['customerEmail'].length)
            ) {
                if (!data.customer.firstName || !data.customer.firstName.length) {
                    this.msg['customerName'] = 'Debe Ingresar el nombre.';
                }
                if (!data.customer.phone || !data.customer.phone.length) {
                    this.msg['customerPhone'] = 'Debe Ingresar un número.';
                }

                return false;
            } else if (!data.issueDescription || !data.issueDescription.length ||
                !data.deviceBrand || !data.deviceBrand.length ||
                !data.serialNo || !data.serialNo.length
            ) {

                if (!data.issueDescription || !data.issueDescription.length ) {
                    this.msg['description'] = 'Descripción inicial requerida.';
                }
                if (!data.deviceBrand || !data.deviceBrand.length) {
                    this.msg['deviceBrand'] = 'Debe Ingresar una Marca.';
                }
                if (!data.serialNo || !data.serialNo.length ) {
                    this.msg['serialNo'] = 'Debe Ingresar serie.';
                }

                return false;
            }
            return true;
        },
        selectCustomer(customer) {
            this.selectedCustomer = true;
            this.issue.customer = customer;
            // This don't need any further validation.
            this.msg['customerName'] = '';
            this.msg['customerPhone'] = '';
            this.msg['customerEmail'] = '';
        },
        toggleEmailInput(notReset) {
            if (this.disableEmail || !notReset) {
                this.issue.customer.email = '';
                this.disableEmail = false;
            } else {
                this.issue.customer.email = 'elusuarionotienemail@gmail.com';
                this.disableEmail = true;
            }
        },
        saveIssue() {
            var self = this;
            var data = {
                accesorios: this.issueValues[4],
                issueDescription: this.issue.description,
                customer: this.issue.customer,
                issueType: this.issue.issueType,
                documentReferredId: this.issue.documentReferredId,
                documentReferredDate: this.issue.documentReferredDate,
                priority: this.issue.priority,
                deviceBrand: this.issue.deviceBrand,
                sku: this.issue.sku,
                serialNo: this.issue.serialNo
            };


            if (!this.processing && this.validForm(data)) {
                this.processing = true;

                if (data.priority === '') {
                    data.priority = null;
                }

                IssueService.saveIssue(data)
                    .then(response => {
                        self.issue.id = response.data.id;
                        // forzar accesorios al pdf :)
                        response.data.accesorios = `Accesorios: ${data.accesorios}`;

                        import('@/utils/export-pdf').then(pdf => {
                            pdf.openingCase(response.data);
                        });
                        self.$store.dispatch('issues/addIssue', response.data);
                        self.submitted = true;

                        // If issue customer email is setted, send Created mail.
                        if (response.data.customer && response.data.customer.email !== 'elusuarionotienemail@gmail.com') {
                            response.data.emailFoot = self.getConditions(response.data);
                            self.sendMail(response.data);
                        }

                        if (self.extraFields.length) {
                            // save extrafield Values. not really needed the condition before but...
                            self.extraFields.forEach(function eachExtraField(extraField) {
                                var efValue = {
                                    extrafield: extraField,
                                    value: self.issueValues[extraField.id]
                                };

                                if (extraField.type !== 'MULTIVALUE') {
                                    ExtraFieldService.saveExtraFieldValue(self.issue.id, efValue).then(
                                        response1 => {
                                            // its ok... ?
                                        },
                                        error => {
                                            // sth wrng
                                            console.log(error.response && error.response.data ||
                                    error.message || error.toString());
                                        }
                                    );
                                }
                            });
                        }

                        setTimeout(function forceNewCustomerControl() {
                            self.newCustomer();
                        }, 5000);
                        this.processing = false;
                    },
                    error => {
                        if (error.response.status === 403) {
                            self.msg['customerName'] = 'Este cliente está deshabilitado.';
                        }

                        console.log(error.response && error.response.data ||
                            error.message || error.toString());
                    });

            }
        },
        initializeExtrafields() {
            var self = this;
            this.extraFields = [];
            ExtraFieldService.getInitial()
                .then(response => {
                    this.extraFields = response.data;
                    this.extraFields.forEach(function eachExtraField(extraField) {
                        if (extraField.defaultValue) {
                            self.issueValues[extraField.id] = extraField.defaultValue;
                        } else {
                            self.issueValues[extraField.id] = '';
                        }
                    });
                },
                error => {
                    console.log(error.response && error.response.data ||
                        error.message || error.toString());
                });
        },
        getConditions(issue) {
            if (issue.issueType === 'Presupuesto') {
                return '<p style="font-size:9px;"><b>CONDICIONES DE SERVICIO TECNICO PARA PRESUPUESTAR</b><br>' +
    '<ol style="font-size:9px;"><li>Si el equipo contiene claves, contraseñas o patrón de desbloqueo que impidan la prueba correcta del mismo. Cliente puede aportarlas. En el caso de tener datos que consideren privados la empresa no tiene responsabilidad sobre los mismos, el cliente puede optar no aportar las calves retirarlo y traerlo nuevamente sin las mismas o que se realize la reparación sin la prueba correcta estando informado que no se pudo probar.</li>' +
    '<li>El Producto deberá ser retirado con presentación de la orden de servicio emitida por SMART DRONE SERVICE al momento de ingreso del mismo al taller.</li>' +
    '<li>Para los articulos/productos que requieran costo también deberá ser presentada la factura emitida por SMART DRONE SERVICE, en conjunto con lo dicho en el Numeral 2.</li>' +
    '<li>El cliente se compromete a declarar todos los fallos del Producto. La reparacion sera efectuada sobre lo declarado por el cliente, si en el proceso se detecta (No sera probadas todas las funciones buscando alguna otra falla)  alguna falla mas sera informado.</li>' +
    '<li>SMART DRONE SERVICE no se hace responsable de fallos no declarados.</li>' +
    '<li>SMART DRONE SERVICE no se hace responsable de los datos que pueda tener almacenados el cliente en el Producto, es responsabilidad del cliente tener respaldo de los mismos. Si los procesos de reparación requieren eliminar los datos se realizara sin previo aviso.</li>' +
    '<li>Las reparaciones tienen 30 días de garantía, sobre la reparación y comienza desde la fecha de Factura.</li>' +
    '<li>La garantía quedará invalidada en los siguientes casos :<br>' +
        ' A) Cualquier manipulación externa sea de Software o Hardware, siendo realizada por el Usuario o por otro Servicio Técnico.<br>' +
        ' B) Cualquier uso no debido del Producto tal como: caída, golpe fuerte, mal uso, contacto con humedad, liquido corrosivo o manipulación.</li>' +
    '<li>SMART DRONE SERVICE no se hace responsable por accesorios dejados como "chips", "memorias" o "vidrios templado" etc.</li>' +
    '<li>SMART DRONE SERVICE queda exenta de toda responsabilidad de cualquier otro tipo de fallo que no tenga relación directa con la reparación realizada.</li>' +
    '<li>El cliente dispone de 60 días posterior al aviso via e-mail o whatsapp para retirar el producto sin costo adicional, una vez cumplido este plazo se cobrara un costo adicional de U$S 2 costo por día por concepto de almacenamiento.</li>' +
    '<li>Es responsabilidad total del cliente revisar el producto en el momento que lo retira, luego de retirado el producto no se admitirán reclamos por estado o accesorios.</li>' +
    '<li>Sera responsabilidad del cliente la comunicación para saber el estado de su presupuesto o reparación. El sistema le notificara automáticamente por e-mail los diferentes estados.</li>' +
    '<li>El Fabricante, Importador o Comerciante: no asume ninguna responsabilidad por el extravío, olvido o desconocimiento de la/s cuenta/s y clave/s asociada/s al dispositivo. El usuario es responsable de su/s cuenta/s y clave/s,  ejemplo: Google, ICloud, BlackBerry ID, MI, entre otros.</li>' +
    '<b style="font-size:9px;>El ingreso de un Producto a Servicio Técnico a SMARTDRONE SERVICE implica el conocimiento y aceptación de estas condiciones.</b>' +
    '</p>';
            }
            return '<p style="font-size:9px;"><b>Condiciones de equipos ingresados para evaluar/tramitar garantía.</b>' +
    '<ol style="font-size:9px;"><li>El equipo ingresa como garantía condicionada, la misma no es comprobada hasta que el equipo es revisado y se constate el cumpliemiento o no, con las normas de garantía.</li>' +
    '<li><u><b>SIEMPRE</b></u> es necesario la presentación de la factura original para la acreditación de la garantía.</li>' +
    '<li>El Producto deberá ser retirado con presentación de la orden de servicio emitida por SMART DRONE SERVICE al momento de ingreso del mismo, al taller.</li>' +
    '<li>Para los Productos que requieran costo también deberá ser presentada la factura emitida por SMART DRONE SERVICE en conjunto con lo dicho en el punto 2.</li>' +
    '<li>El cliente se compromete a declarar todos los fallos del articulo/producto.</li>' +
    '<li>SMART DRONE SERVICE no se hace responsable de fallos no declarados.</li>' +
    '<li>SMART DRONE SERVICE no se hace responsable de los datos que pueda tener almacenados el cliente en el Producto, es responsabilidad del cliente tener respaldo de los mismos. Si los procesos de reparación requieren <b>eliminar los datos se realizara sin previo aviso.</b></li>' +
    '<li>SMART DRONE SERVICE no se hace responsable por accesorios dejados como "chips", "memorias" o "vidrios templados".</li>' +
    '<li>Si el equipo contiene claves, contraseñas o patrón de desbloqueo que impidan la prueba correcta del mismo. No sera revisado hasta aportar las mismas o serán borradas si el equipo lo permite. En el caso de tener datos que consideren privados la empresa no tiene responsabilidad sobre los mismos, el cliente puede optar no aportar las calves retirarlo y traerlo nuevamente sin las mismas.</li>' +
    '<li>Será responsabilidad del cliente la comunicación para saber el estado de su reparación.</li>' +
    '<li>SMART DRONE SERVICE queda exenta de toda responsabilidad de cualquier otro tipo de fallo que no tenga relación directa con la reparación realizada.</li>' +
    '<li>El cliente dispone de 60 días posterior al aviso via e-mail para retirar el producto sin costo adicional, una vez cumplido este plazo se cobrara un costo adicional de U$S 2 por día de uso del almacén.</li>' +
    '<li>Es responsabilidad total del cliente revisar el producto en el momento que lo retira, luego de retirado el producto no se admitirán reclamos por estado o accesorios.</li>' +
    '<li> Para hacer efectiva la garantía del dispositivo debe de tener desvinculadas todas la/s cuenta/s existentes en el mismo.</li></ol>' +
    '<span style="font-size:9px;">El Fabricante, Importador o Comerciante: no asume ninguna responsabilidad por el extravío, olvido o desconocimiento de la/s cuenta/s y clave/s asociada/s al dispositivo. El usuario es responsable de su/s cuenta/s y clave/s, ejemplo: Google, ICloud, BlackBerry ID, MI, entre otros.</span><br>' +
    '<b style="font-size:9px;">El ingreso de un Producto a Servicio Técnico proporcionado por SMART DRONE SERVICE implica el conocimiento y aceptación de estas condiciones.</b>' +
    '</p>';
        },
        newCustomer() {
            this.submitted = false;
            this.selectedCustomer = false;
            this.customers = [];
            this.toggleEmailInput(false);
            this.issue = {
                description: '',
                issueType: null,
                priority: null,
                customer: {
                    id: -1,
                    firstName: '',
                    email: '',
                    phone: ''
                },
                documentReferredId: '',
                documentReferredDate: '',
                deviceBrand: '',
                sku: '',
                serialNo: ''
            };
            this.msg = {
                customerEmail: '',
                customerName: '',
                customerPhone: '',
                description: '',
                deviceBrand: '',
                sku: '',
                serialNo: ''
            };
            this.initializeExtrafields();
        }
    /* eslint-enable no-console */
    }
};
</script>

<style lang="scss">
@import "../../styles/theme.scss";

$ef-border: darken($issue-border, 8%);

.add-issue-page {
    padding: 14px 14px 24px;
    background-color: #fff;

    .alert-msg {
        color: $issue-danger;
        display: block;
        font-size: 11.5px;
        margin-top: 3px;
    }

    .add-issue-sheet {
        max-width: 980px;
        margin: 0 auto;
    }

    .form-section {
        padding: 16px 0;
        border-top: 1px solid $issue-border;

        &:first-child {
            border-top: none;
            padding-top: 4px;
        }
    }

    h5 {
        font-size: 12px;
        font-weight: 700;
        color: $issue-text-muted;
        text-transform: uppercase;
        letter-spacing: 0.06em;
        margin-bottom: 14px;
    }

    .field {
        margin-bottom: 12px;

        label {
            display: block;
            margin-bottom: 4px;
            font-size: 12px;
            font-weight: 600;
            color: $issue-text-muted;
        }
    }

    .form-control,
    .custom-select {
        width: 100%;
        border: 1px solid $ef-border;
        border-radius: $issue-radius-sm;
        font-size: 13.5px;
        color: $issue-text;
        padding: 7px 10px;
        background-color: #fff;
        transition: border-color .12s ease, box-shadow .12s ease;

        &:focus {
            border-color: $issue-primary;
            box-shadow: 0 0 0 3px $issue-primary-soft;
            outline: none;
        }
        &:disabled {
            background-color: $issue-bg-subtle;
            color: $issue-text-muted;
        }
    }

    .ta-fill {
        min-height: 92px;
        resize: vertical;
    }

    .date-hint {
        margin: 4px 0 0;
        font-size: 12px;
        color: $issue-text-muted;
    }

    .field-with-action {
        display: flex;
        gap: 6px;

        .form-control {
            flex: 1 1 auto;
            min-width: 0;
        }
        .btn {
            flex: 0 0 auto;
            border-radius: $issue-radius-sm;
            font-size: 12.5px;
            white-space: nowrap;
        }
    }

    .radio-pair {
        display: flex;
        gap: 18px;
        align-items: center;
        min-height: 34px;
        font-size: 13.5px;

        label {
            display: inline-flex;
            align-items: center;
            gap: 5px;
            font-weight: 400;
            color: $issue-text;
            margin: 0;
        }
    }

    .checkbox-single {
        min-height: 34px;
        display: flex;
        align-items: center;
    }

    .suggestions {
        max-width: 500px;
    }

    .list-group {
        border-radius: $issue-radius-sm;
        overflow: hidden;
        box-shadow: $issue-shadow-sm;

        .list-group-item {
            border-color: $issue-border;
            font-size: 13px;
            &.active {
                background-color: $issue-primary;
                border-color: $issue-primary;
            }
        }
    }

    .form-actions {
        display: flex;
        gap: 10px;
        margin-top: 8px;
        padding-top: 16px;
        border-top: 1px solid $issue-border;

        .btn {
            border-radius: $issue-radius-sm;
            font-weight: 600;
            padding: 8px 20px;
            transition: transform .12s ease, box-shadow .12s ease;
            &:hover { transform: translateY(-1px); box-shadow: $issue-shadow-sm; }
        }
    }

    .btn-reset {
        margin-left: 0;
    }

    .success-panel {
        max-width: 480px;
        margin: 40px auto;
        text-align: center;

        h4 {
            color: $issue-success;
            font-weight: 700;
            margin-bottom: 18px;
        }

        .btn {
            border-radius: $issue-radius-sm;
            font-weight: 600;
            padding: 8px 20px;
        }
    }

    @media(max-width: 600px) {
        padding: 12px 12px 20px;

        .field-with-action {
            flex-direction: column;
            align-items: stretch;
        }
    }
}
</style>
